export default function AppContactSection() {
  return (
    <>
      <section id="app" className="relative py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-gradient-to-br from-primary-500 to-primary-600 rounded-2xl p-8 md:p-12 overflow-hidden relative">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-[-20%] right-[-10%] w-64 h-64 bg-background-50 rounded-full"></div>
              <div className="absolute bottom-[-20%] left-[-5%] w-48 h-48 bg-background-50 rounded-full"></div>
            </div>

            <div className="flex-1 relative z-10 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-3">
                手机观看更便捷
              </h2>
              <p className="text-sm md:text-base text-background-50/90 leading-relaxed mb-5">
                91吃瓜爆料网全面适配移动端访问，无需下载安装任何APP。打开手机浏览器即可畅享91吃瓜视频在线观看与91吃瓜在线播放，随时随地吃瓜不耽误。收藏本站，下次访问更快捷。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
                <div className="flex items-center gap-2 px-4 py-2 bg-background-50/20 rounded-lg">
                  <i className="ri-smartphone-line text-background-50 text-lg"></i>
                  <span className="text-sm text-background-50 whitespace-nowrap">手机浏览器直达</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 bg-background-50/20 rounded-lg">
                  <i className="ri-qr-code-line text-background-50 text-lg"></i>
                  <span className="text-sm text-background-50 whitespace-nowrap">扫码即看</span>
                </div>
              </div>
            </div>

            <div className="flex-shrink-0 relative z-10">
              <div className="w-40 h-40 md:w-48 md:h-48 bg-background-50 rounded-2xl flex items-center justify-center">
                <div className="text-center">
                  <i className="ri-qr-code-line text-6xl text-primary-500"></i>
                  <p className="text-xs text-foreground-400 mt-2">扫码访问</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="contact" className="relative py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="max-w-2xl mx-auto text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-accent-100 rounded-2xl mx-auto mb-5">
              <i className="ri-mail-send-line text-2xl text-accent-600"></i>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              爆料投稿与联系
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6">
              你有一手爆料线索或精彩吃瓜素材？欢迎通过以下方式联系我们。91吃瓜爆料网重视每一位瓜友的投稿，优质内容将有专人跟进核实，让你的爆料被更多人看到。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <div className="flex items-center gap-2 px-5 py-3 bg-background-50 border border-background-200/70 rounded-lg cursor-default">
                <i className="ri-mail-line text-primary-500 text-lg"></i>
                <span className="text-sm text-foreground-600">91chigua@爆料投稿.com</span>
              </div>
              <div className="flex items-center gap-2 px-5 py-3 bg-background-50 border border-background-200/70 rounded-lg cursor-default">
                <i className="ri-wechat-line text-accent-500 text-lg"></i>
                <span className="text-sm text-foreground-600">微信：91chigua666</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}